<template>
  <el-card>
    <div style="hight: 494px">
      <!-- 头部 -->
      <el-row :gutter="24">
        <el-col :span="7">
          <div style="font-size: 30px">
            {{
              isBaoShen ? "总体审核情况监测" : "总体执行情况监测"
            }}&nbsp;&nbsp;&nbsp;
            <span style="font-size: 26px">{{ time }}</span>
          </div>
        </el-col>
        <el-col v-if="!isBaoShen" :span="5" class="flex">
          <div style="margin-top: 10px">任务总进度</div>
          <div style="width: 70%">
            <el-progress
              :text-inside="true"
              style="margin-top: 10px"
              :color="colors"
              :stroke-width="26"
              :percentage="progressNumber"
            ></el-progress>
          </div>
        </el-col>
        <el-col :span="4" :offset="isBaoShen ? 5 : 0" class="flex">
          <div>计划</div>
          <el-select
            @change="changePlan"
            style="width: 80%"
            v-model="planId"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in planList"
              :key="item.zwpp01"
              :label="item.zwpp03"
              :value="item.zwpp01"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5" class="flex">
          <div>负责人</div>
          <el-select
            @change="changeUser"
            v-model="userId"
            filterable
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in userlist"
              :key="item.user01"
              :label="item.user04"
              :value="item.user01"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" size="default" @click="changeYeMian">
            {{ isBaoShen ? "总体执行情况监测" : "总体审核情况监测" }}</el-button
          >
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :offset="0">
          共{{ myFiles.filter((ele) => ele.zwpm08 === 2).length }}个BIM模型，{{
            myFiles.filter((ele) => ele.zwpm08 === 3).length
          }}张图纸，{{ myFiles.filter((ele) => ele.zwpm08 === 4).length }}个文档
        </el-col>
      </el-row>

      <!-- 审核 -->
      <el-row :gutter="24" style="margin-top: 30px">
        <el-col :span="3" :offset="0" style="text-align: right">
          <div style="overflow: hidden; margin: 0">
            <h2>{{ isBaoShen ? "总审核项" : "总任务数" }}</h2>
            <h1 style="font-weight: 700; color: #000; font-size: 24px">
              {{ zong }}
            </h1>
            <h2>{{ isBaoShen ? "审核中任务数" : "进行中任务数" }}</h2>
            <h1 style="font-weight: 700; color: #8666ba; font-size: 24px">
              {{ jinxing }}
            </h1>
            <h2>{{ isBaoShen ? "已审核任务数" : "已完成任务数" }}</h2>
            <h1 style="font-weight: 700; color: #42b789; font-size: 24px">
              {{ yiwancheng }}
            </h1>
            <h2>{{ isBaoShen ? "未审核任务数" : "未启动任务数" }}</h2>
            <h1 style="font-weight: 700; color: #f98017; font-size: 24px">
              {{ weiqi }}
            </h1>
            <h2>{{ isBaoShen ? "已延期审核项" : "已延期任务数" }}</h2>
            <h1 style="font-weight: 700; color: #f98017; font-size: 24px">
              {{ yiyanqi }}
            </h1>
            <h2>风险预警项</h2>
            <h1 style="font-weight: 700; color: #cc0000; font-size: 24px">
              {{ wxrw }}
            </h1>
          </div>
        </el-col>
        <el-col :span="11" :offset="0">
          <v-chart theme="macarons" style="width: 100%" :options="polar" />
        </el-col>
        <el-col :span="10" :offset="0">
          <v-chart theme="macarons" style="width: 100%" :options="polar2" />
        </el-col>
      </el-row>
    </div>
    <!-- 甘特图 -->
    <el-row :gutter="24">
      <el-col :span="3">
        <div
          style="
            width: 60px;
            height: 30px;
            background-color: red;
            border-radius: 4px;
            float: left;
          "
        ></div>
        <p style="margin: 5px 0 0 10px; float: left">风险预警</p>
      </el-col>
      <el-col :span="2" :offset="19">
        <el-button type="primary" @click="ganttShow = !ganttShow"
          >甘特图</el-button
        >
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row v-if="ganttShow">
      <el-col :span="24">
        <el-table
          v-if="!isBaoShen"
          v-loading="loading"
          :data="tableData"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          height="72vh"
          row-key="zwpd01"
          :highlight-current-row="true"
          default-expand-all
          :tree-props="{ children: 'children' }"
        >
          <el-table-column property="zwpd04" label="任务名称">
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <p
                :style="{
                  background: scope.row.isDanger === 1 ? 'red' : '',
                  textAlign: 'center',
                  color: '#000',
                  height: '28px',
                  lineHeight: '28px',
                  borderRadius: '10px',
                }"
              >
                {{ isBaoShen ? scope.row.auditstate : scope.row.state }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="责任人" align="center" prop="fzr">
          </el-table-column>
          <el-table-column label="审核人" align="center" prop="shr">
          </el-table-column>
          <el-table-column property="planDays" label="计划工作时长">
          </el-table-column>
          <el-table-column property="trueDays" label="实际工作时长">
          </el-table-column>
          <el-table-column property="zwpd14" label="里程碑">
            <template slot-scope="scope">
              <el-switch
                disabled
                v-model="scope.row.zwpd14"
                :active-value="1"
                :inactive-value="0"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column property="zwpd05" label="计划开始时间">
          </el-table-column>
          <el-table-column property="zwpd06" label="计划完成时间">
          </el-table-column>
          <el-table-column property="zwpd07" label="最迟完成时间">
          </el-table-column>
          <el-table-column property="zwpd08" label="审核结束时间">
          </el-table-column>
          <el-table-column property="zwpd09" label="实际开始时间">
          </el-table-column>
          <el-table-column property="zwpd10" label="实际完成时间">
          </el-table-column>
          <el-table-column property="zwpd11" label="备注"> </el-table-column>
        </el-table>

        <el-table
          v-if="isBaoShen"
          v-loading="loading"
          :data="tableData"
          height="72vh"
        >
          <el-table-column property="zwpd04" label="任务名称">
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <p
                :style="{
                  background: scope.row.isAuditDanger === 1 ? 'red' : '',
                  textAlign: 'center',
                  color: '#000',
                  height: '28px',
                  lineHeight: '28px',
                  borderRadius: '10px',
                }"
              >
                {{ isBaoShen ? scope.row.auditstate : scope.row.state }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="责任人" align="center" prop="fzr">
          </el-table-column>
          <el-table-column label="审核人" align="center" prop="shr">
          </el-table-column>
          <el-table-column property="planDays" label="计划工作时长">
          </el-table-column>
          <el-table-column property="trueDays" label="实际工作时长">
          </el-table-column>
          <el-table-column property="zwpd14" label="里程碑">
            <template slot-scope="scope">
              <el-switch
                disabled
                v-model="scope.row.zwpd14"
                :active-value="1"
                :inactive-value="0"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column property="zwpd05" label="计划开始时间">
          </el-table-column>
          <el-table-column property="zwpd06" label="计划完成时间">
          </el-table-column>
          <el-table-column property="zwpd07" label="最迟完成时间">
          </el-table-column>
          <el-table-column property="zwpd08" label="审核结束时间">
          </el-table-column>
          <el-table-column property="zwpd09" label="实际开始时间">
          </el-table-column>
          <el-table-column property="zwpd10" label="实际完成时间">
          </el-table-column>
          <el-table-column property="zwpd11" label="备注"> </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <gantt v-else :gantData="gantData"></gantt>
  </el-card>
</template>

<script>
import { deteleObject } from "@/tools/tool.js";
import gantt from "@/components/gantt.vue";
import {
  GetZjwjProjectPlan,
  GetAuditUserList2,
  GetZjwjMyFile,
  ZjwjAuditList,
} from "@/setAxios";
export default {
  name: "",
  components: { gantt },
  props: {},
  data() {
    return {
      ganttShow: true,
      gantData: {
        id: "",
      },
      yeMianName: "总体审核情况监测",
      isBaoShen: false,
      planList: [],
      planId: "",
      userlist: [],
      userId: "",
      myFiles: [],
      loading: false,
      time: new Date().toLocaleString(),
      progressNumber: 0,
      colors: [
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "#5cb87a", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#6f7ad3", percentage: 100 },
      ],
      value: "",
      polar: {},
      polar2: {},
      tableData: [],
      zong: 0,
      weiqi: 0,
      jinxing: 0,
      yiyanqi: 0,
      yiwancheng: 0,
      wxrw: 0,
      ecahrtsTwoData: {
        fzList: [],
        shList: [],
      },
      tableData2: [],
    };
  },
  created() {
    this.GetZjwjProjectPlan();
    this.GetAuditUserList2();
  },
  methods: {
    async changeUser(data) {
      this.userId = data;
      this.GetZjwjMyFile();
      this.resetEchartsData();
      this.ZjwjAuditList();
    },
    changeYeMian() {
      this.isBaoShen = !this.isBaoShen;
      this.resetEchartsData();
      this.ZjwjAuditList();
    },
    changePlan(data) {
      this.planId = data;
      this.gantData.id = data;
      this.ganttShow = true;
      this.resetEchartsData();
      this.ZjwjAuditList();
    },
    async ZjwjAuditList() {
      this.loading = true;
      let res = await ZjwjAuditList({
        params: { id: this.planId, uid: this.userId },
      });
      this.tableData = res.Data;
      // 这里挑取最底层的数据进行赋值
      this.tableData2 = [];
      this.initData(this.tableData);
      this.tableData = this.tableData2;
      this.initEcharts2(this.tableData);
      this.polar2 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: this.isBaoShen
            ? ["审核中任务项", "已审核任务项", "未审核任务项", "已延期审核项"]
            : ["进行中任务", "已完成任务", "未启动任务", "已延期任务"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: (() => {
            let userNameArr = [];
            if (this.isBaoShen) {
              this.ecahrtsTwoData.shList.forEach((ele) => {
                userNameArr.push(ele.user04);
              });
            } else {
              this.ecahrtsTwoData.fzList.forEach((ele) => {
                userNameArr.push(ele.user04);
              });
            }
            return userNameArr;
          })(),
        },
        series: [
          {
            name: this.isBaoShen ? "审核中任务项" : "进行中任务",
            type: "bar",
            stack: "总量",
            data: (() => {
              let DataArr = [];
              if (this.isBaoShen) {
                this.ecahrtsTwoData.shList.forEach((ele) => {
                  DataArr.push(ele.shz);
                });
              } else {
                this.ecahrtsTwoData.fzList.forEach((ele) => {
                  DataArr.push(ele.shz);
                });
              }
              return DataArr;
            })(),
          },
          {
            name: this.isBaoShen ? "已审核任务项" : "已完成任务",
            type: "bar",
            stack: "总量",
            data: (() => {
              let DataArr = [];
              if (this.isBaoShen) {
                this.ecahrtsTwoData.shList.forEach((ele) => {
                  DataArr.push(ele.ysh);
                });
              } else {
                this.ecahrtsTwoData.fzList.forEach((ele) => {
                  DataArr.push(ele.ysh);
                });
              }
              return DataArr;
            })(),
          },
          {
            name: this.isBaoShen ? "未审核任务项" : "未启动任务",
            type: "bar",
            stack: "总量",
            data: (() => {
              let DataArr = [];
              if (this.isBaoShen) {
                this.ecahrtsTwoData.shList.forEach((ele) => {
                  DataArr.push(ele.wsh);
                });
              } else {
                this.ecahrtsTwoData.fzList.forEach((ele) => {
                  DataArr.push(ele.wsh);
                });
              }
              return DataArr;
            })(),
          },
          {
            name: this.isBaoShen ? "已延期审核项" : "已延期任务",
            type: "bar",
            stack: "总量",
            data: (() => {
              let DataArr = [];
              if (this.isBaoShen) {
                this.ecahrtsTwoData.shList.forEach((ele) => {
                  DataArr.push(ele.yyq);
                });
              } else {
                this.ecahrtsTwoData.fzList.forEach((ele) => {
                  DataArr.push(ele.yyq);
                });
              }
              return DataArr;
            })(),
          },
        ],
      };
      this.initEcharts();
      this.progressNumber = 0;
      if (this.tableData.length > 0) {
        this.tableData.forEach((ele) => {
          this.progressNumber += Number(ele.wcjd);
        });
        this.progressNumber = Math.floor(
          this.progressNumber / this.tableData.length
        );
      }
      this.loading = false;
    },
    initData(data) {
      data.forEach((ele) => {
        ele.fzId = ele.fzList.length > 0 ? ele.fzList[0].user01 : "";
        ele.shId = ele.shList.length > 0 ? ele.shList[0].user01 : "";
        ele.fzr = [];
        ele.fzList.forEach((ele2) => {
          ele.fzr.push(ele2.user04);
        });
        ele.fzr = ele.fzr.join(",");
        ele.shr = [];
        ele.shList.forEach((ele2) => {
          ele.shr.push(ele2.user04);
        });
        ele.shr = ele.shr.join(",");
        if (ele.children.length === 0) {
          let userOptionArr = [];
          let userOptionArr2 = [];
          ele.fzList.forEach((ele2) => {
            let userOption = {
              user01: ele2.user01,
              user02: ele2.user02,
              user04: ele2.user04,
              shz: 0,
              ysh: 0,
              wsh: 0,
              yyq: 0,
            };
            userOptionArr.push(userOption);
          });
          ele.shList.forEach((ele2) => {
            let userOption2 = {
              user01: ele2.user01,
              user02: ele2.user02,
              user04: ele2.user04,
              shz: 0,
              ysh: 0,
              wsh: 0,
              yyq: 0,
            };
            userOptionArr2.push(userOption2);
          });
          this.ecahrtsTwoData.fzList = [
            ...this.ecahrtsTwoData.fzList,
            ...userOptionArr,
          ];
          this.ecahrtsTwoData.shList = [
            ...this.ecahrtsTwoData.shList,
            ...userOptionArr2,
          ];
          if (this.isBaoShen) {
            if (ele.auditstate !== "--") {
              this.zong++;
              switch (ele.auditstate) {
                case "已审核正常":
                  this.yiwancheng++;
                  break;
                case "审核中正常":
                  this.jinxing++;
                  break;
                case "未审核正常":
                  this.weiqi++;
                  this.yiyanqi++;
                  break;
                case "已审核延期":
                  this.yiwancheng++;
                  break;
                case "审核中延期":
                  this.jinxing++;
                  this.yiyanqi++;
                  break;
                case "未审核延期":
                  this.weiqi++;
                  this.yiyanqi++;
                  break;
              }
              switch (ele.isAuditDanger) {
                case 0:
                  break;
                case 1:
                  this.wxrw++;
                  break;
              }
              this.tableData2.push(ele);
            }
          } else {
            this.zong++;
            switch (ele.state) {
              case "未启动正常":
                this.weiqi++;
                break;
              case "未启动延期":
                this.weiqi++;
                this.yiyanqi++;
                break;
              case "进行中正常":
                this.jinxing++;
                break;
              case "进行中延期":
                this.jinxing++;
                this.yiyanqi++;
                break;
              case "已完成正常":
                this.yiwancheng++;
                break;
              case "已完成延期":
                this.yiwancheng++;
                break;
            }
            switch (ele.isDanger) {
              case 0:
                break;
              case 1:
                this.wxrw++;
                break;
            }
            this.tableData2.push(ele);
          }
        }
        if (ele.children.length > 0) {
          this.initData(ele.children);
        }
      });
    },
    initEcharts() {
      this.polar = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: 10,
          data: this.isBaoShen
            ? ["审核中任务项", "已审核任务项", "未审核任务项", "风险预警项"]
            : ["进行中任务", "已完成任务", "未启动任务", "风险预警项"],
        },
        series: [
          {
            name: "风险",
            type: "pie",
            radius: [0, "30%"],
            data: [{ value: this.wxrw, name: "风险预警项" }],
            label: {
              normal: {
                show: false,
              },
            },
          },
          {
            name: this.isBaoShen ? "报审" : "计划",
            type: "pie",
            radius: ["40%", "55%"],
            data: this.isBaoShen
              ? [
                  { value: this.jinxing, name: "审核中任务项" },
                  { value: this.yiwancheng, name: "已审核任务项" },
                  { value: this.weiqi, name: "未审核任务项" },
                ]
              : [
                  { value: this.jinxing, name: "进行中任务" },
                  { value: this.yiwancheng, name: "已完成任务" },
                  { value: this.weiqi, name: "未启动任务" },
                ],

            label: {
              //去除饼图的指示折线label
              normal: {
                show: false,
              },
            },
          },
        ],
      };
    },
    initData2(data) {
      data.forEach((ele) => {
        if (ele.children.length > 0) {
          this.initData2(ele.children);
        }
        if (ele.children.length === 0) {
          // 这里处理项目计划第二个echarts数据
          // 负责的
          this.ecahrtsTwoData.fzList.forEach((ele2) => {
            let filterArr = ele.fzList.filter(
              (ele3) => ele2.user01 === ele3.user01
            );
            if (filterArr.length > 0) {
              switch (ele.state) {
                case "未启动正常":
                  ele2.wsh++;
                  break;
                case "未启动延期":
                  ele2.wsh++;
                  ele2.yyq++;
                  break;
                case "进行中正常":
                  ele2.shz++;
                  break;
                case "进行中延期":
                  ele2.shz++;
                  ele2.yyq++;
                  break;
                case "已完成正常":
                  ele2.ysh++;
                  break;
                case "已完成延期":
                  ele2.ysh++;
                  ele2.yyq++;
                  break;
              }
            }
          });
          this.ecahrtsTwoData.shList.forEach((ele2) => {
            let filterArr = ele.shList.filter(
              (ele3) => ele2.user01 === ele3.user01
            );
            if (filterArr.length > 0) {
              switch (ele.auditstate) {
                case "已审核正常":
                  ele2.ysh++;
                  break;
                case "审核中正常":
                  ele2.shz++;
                  break;
                case "未审核正常":
                  ele2.wsh++;
                  break;
                case "已审核延期":
                  ele2.ysh++;
                  ele2.yyq++;
                  break;
                case "审核中延期":
                  ele2.shz++;
                  ele2.yyq++;
                  break;
                case "未审核延期":
                  ele2.wsh++;
                  ele2.yyq++;
                  break;
              }
            }
          });
          // 审核的
        }
      });
    },
    initEcharts2(data) {
      this.ecahrtsTwoData.fzList = deteleObject(this.ecahrtsTwoData.fzList);
      this.ecahrtsTwoData.shList = deteleObject(this.ecahrtsTwoData.shList);
      this.ecahrtsTwoData.fzList.forEach((ele) => {
        ele.shz = 0;
        ele.ysh = 0;
        ele.wsh = 0;
        ele.yyq = 0;
      });
      this.ecahrtsTwoData.shList.forEach((ele) => {
        ele.shz = 0;
        ele.ysh = 0;
        ele.wsh = 0;
        ele.yyq = 0;
      });
      this.initData2(data);
    },
    resetEchartsData() {
      this.myFileData = [];
      this.zong = 0;
      this.weiqi = 0;
      this.jinxing = 0;
      this.yiyanqi = 0;
      this.yiwancheng = 0;
      this.wxrw = 0;
      this.ecahrtsTwoData.fzList = [];
      this.ecahrtsTwoData.shList = [];
    },
    async GetZjwjProjectPlan() {
      let params = {
        id: localStorage.xid,
        searchword: "",
        pageIndex: 1,
        pageSize: 10000000,
        type: 1,
      };
      let res = await GetZjwjProjectPlan({ params });
      this.planList = res.Data.list;
      if (res.Data.list.length > 0) {
        this.planId = res.Data.list[0].zwpp01;
        this.gantData.id = res.Data.list[0].zwpp01;
        this.ZjwjAuditList();
        this.GetZjwjMyFile();
      }
    },
    async GetZjwjMyFile() {
      let params = {
        id: this.planId,
        uid: this.userId,
      };
      let res = await GetZjwjMyFile({ params });
      this.myFiles = res.Data;
    },
    async GetAuditUserList2() {
      let params = {
        xid: localStorage.xid,
        qid: localStorage.pid,
        ids: "",
      };
      let res = await GetAuditUserList2(params);
      this.userlist = res.Data;
    },
    handleSelectionChange(val) {},
  },
  mounted() {
    setInterval(() => {
      this.time = new Date().toLocaleString();
    }, 1000);
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.flexbetween {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
